/**
 * @flow
 * @relayHash c97435298b88f2fc251a95c9b6d6934b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContactSearchContainer_viewer$ref = any;
export type ContactSearchContainerRefetchQueryVariables = {|
  query: string
|};
export type ContactSearchContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ContactSearchContainer_viewer$ref
  |}
|};
export type ContactSearchContainerRefetchQuery = {|
  variables: ContactSearchContainerRefetchQueryVariables,
  response: ContactSearchContainerRefetchQueryResponse,
|};
*/


/*
query ContactSearchContainerRefetchQuery(
  $query: String!
) {
  viewer {
    ...ContactSearchContainer_viewer_1Qr5xf
    id
  }
}

fragment ContactSearchContainer_viewer_1Qr5xf on User {
  user_contact_search(first: 3, query: $query) {
    edges {
      node {
        id
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              number
              id
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ContactSearchContainerRefetchQuery",
  "id": null,
  "text": "query ContactSearchContainerRefetchQuery(\n  $query: String!\n) {\n  viewer {\n    ...ContactSearchContainer_viewer_1Qr5xf\n    id\n  }\n}\n\nfragment ContactSearchContainer_viewer_1Qr5xf on User {\n  user_contact_search(first: 3, query: $query) {\n    edges {\n      node {\n        id\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              number\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ContactSearchContainerRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContactSearchContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContactSearchContainerRefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contact_search",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": "String!"
              }
            ],
            "concreteType": "UserContactConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContact",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "first_name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "last_name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_contact_emails",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactEmailConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactEmail",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "address",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v1
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_contact_phones",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactPhoneConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactPhoneEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactPhone",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "number",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v1
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a0849079c272046b48419937b17cd36';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/ContactSearchContainerRefetchQuery.graphql.js